import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CONTACT_US_PHONE_MAIN, CONTACT_US_WHATSAPP_MAIN, SUPPORT_EMAIL } from '../../shared/constants';

@Component({
    selector: 'app-support',
    imports: [],
    templateUrl: './support.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './support.component.scss'
})
export class SupportComponent {
  SUPPORT_EMAIL: string = SUPPORT_EMAIL
  CONTACT_US_PHONE_MAIN: string = CONTACT_US_PHONE_MAIN
  CONTACT_US_WHATSAPP_MAIN: string = CONTACT_US_WHATSAPP_MAIN
}
